import { motion } from 'framer-motion';
import { ABOUT_PORTRAIT } from '@/lib/data';

export const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative bg-ink-soft py-24 md:py-32"
        >
            <div className="px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1 }}
                    className="lg:col-span-7"
                >
                    <div className="relative aspect-[16/10] overflow-hidden">
                        <img
                            src={ABOUT_PORTRAIT}
                            alt="Director's signature frame"
                            loading="lazy"
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-ink/30 to-transparent pointer-events-none" />
                    </div>
                    <p className="mt-5 text-[11px] uppercase tracking-[0.3em] text-bone-dim">
                        Balu Cine · Director, Bros On Board
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, delay: 0.2 }}
                    className="lg:col-span-5"
                >
                    <p className="text-xs uppercase tracking-[0.4em] text-gold mb-6">
                        Director's Note
                    </p>
                    <p className="font-serif text-gold text-7xl lg:text-8xl leading-none italic font-light">
                        “
                    </p>
                    <h3 className="font-serif text-bone text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-light leading-[1.15] -mt-6">
                        I don't believe in wedding videos. I believe in love stories told
                        in 24 frames a second — with{' '}
                        <span className="italic text-bone-dim">
                            tension, score, and an ending you didn't see coming.
                        </span>
                    </h3>
                    <div className="mt-10 grid grid-cols-2 gap-8 max-w-md">
                        <div>
                            <p className="font-serif text-bone text-3xl mb-1">8</p>
                            <p className="text-[11px] uppercase tracking-[0.25em] text-bone-dim">
                                Years Behind The Lens
                            </p>
                        </div>
                        <div>
                            <p className="font-serif text-bone text-3xl mb-1">200+</p>
                            <p className="text-[11px] uppercase tracking-[0.25em] text-bone-dim">
                                Couples Directed
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
